class ReadMore extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!this.els['full-content'].element) return

    this.setupListeners()
  }

  setupListeners () {
    super.setupListeners()

    this.showFullContent = this.showFullContent.bind(this)
    this.hideFullContent = this.hideFullContent.bind(this)

    this.els['read-more'].elements.forEach(readMore => {
      this.listeners.add(readMore, 'click', this.showFullContent)
    })
    this.els['read-less'].elements.forEach(readLess => {
      this.listeners.add(readLess, 'click', this.hideFullContent)
    })
  }

  showFullContent () {
    this.els['full-content'].element.setAttribute('aria-hidden', 'false')
    this.els['short-content'].element.setAttribute('aria-hidden', 'true')
  }

  hideFullContent () {
    this.els['full-content'].element.setAttribute('aria-hidden', 'true')
    this.els['short-content'].element.setAttribute('aria-hidden', 'false')
  }
}

if (!customElements.get('read-more')) {
  customElements.define('read-more', ReadMore)
}
